export default __webpack_public_path__ + "static/Wideangle_Lense_18mm_Angle_of_View-baf24800790bcd4dbf65a62415747f48.webp";